import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';

const TextInput = ({ name, type, layout, label, error, ...rest }) => <>
    <Row className='form-group'>
        <Col xs={layout[0]} style={{fontWeight:'bold'}} ><label htmlFor={name}>{label}</label></Col>
        <Col xs={layout[1]}>
        <input
            type = {type || 'text'}
            id = {name}
            name={name}
            className="form-control"
            {...rest}
        />
        </Col> 
    </Row>
    <Row><Col xs='12'>{error && <div className="alert alert-danger">{error}</div>}</Col></Row>
</>;

TextInput.defaultProps = {
    layout: [2,10]
  };

TextInput.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    layout: PropTypes.array,
    error: PropTypes.string
  };

export default TextInput;